import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteSchoolFacialDevice(context, payload) {
    ApiService.setHeader();
    return ApiService.delete("school/device/facial", {
      params: {
        id: payload,
      },
    }).then((response) => response);
  },
};

export default {
  actions,
};
